module.exports = __webpack_public_path__ + "static/media/redeem-brand-icon.eb3cd532.svg";